var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-meta__item" }, [
    _vm.icon ? _c("i", { class: `fa fa-${_vm.icon} fa-fw` }) : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "list-meta__label" },
      [
        _vm.booking.date_options
          ? [_vm._v("Date Options:")]
          : [_vm._v("Event Date:")],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "list-meta__text" },
      [
        _vm.booking.date_options
          ? [
              _vm._v(
                _vm._s(
                  _vm._f("nullable")(
                    _vm._f("implodeDates")(
                      _vm.booking.date_options,
                      _vm.$user.date_format_preference
                    )
                  )
                )
              ),
            ]
          : _vm.booking.date
          ? [
              _vm._v(
                _vm._s(
                  _vm._f("nullable")(
                    _vm._f("date")(
                      _vm.dateUserTz,
                      _vm.$user.date_format_preference
                    )
                  )
                )
              ),
            ]
          : [_vm._v("Date is unconfirmed")],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }